import theme from './theme.grey';
export default {
  "title": "Test varsel",
  "label": "Forum",
  "attachments": [],
  "appName": "Forum",
  "updatedAt": "2019-09-16T13:41:29.608000+00:00",
  "ownerId": null,
  "inboxType": "forum",
  "appColor": "",
  "uniqueId": "1525",
  "messages": [{
    "author": {
      "name": "\u00d8yvind Volden",
      "email": "N/A"
    },
    "message": "<p>Tester notifications. Kanskje du kan svare p\u00e5 denne posten <a class=\"mention\" href=\"/u/Gunn_Walmann\">@Gunn_Walmann</a> ?</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "1",
    "createdAt": "2019-09-09T11:06:45.573000+00:00"
  }, {
    "author": {
      "name": "Gunn Walmann",
      "email": "N/A"
    },
    "message": "<p>Da fikk jeg en epost gitt!<br>\nM\u00e5 v\u00e6re noe som fungerer her.<br>\n<img src=\"https://discourse.dimu.org/images/emoji/google/grinning.png?v=9\" title=\":grinning:\" class=\"emoji\" alt=\":grinning:\"><img src=\"https://discourse.dimu.org/images/emoji/google/ok_hand.png?v=9\" title=\":ok_hand:\" class=\"emoji\" alt=\":ok_hand:\"><img src=\"https://discourse.dimu.org/images/emoji/google/+1.png?v=9\" title=\":+1:\" class=\"emoji\" alt=\":+1:\"></p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "2",
    "createdAt": "2019-09-09T11:20:58.755000+00:00"
  }, {
    "author": {
      "name": "Gunn Walmann",
      "email": "N/A"
    },
    "message": "<p>svar \u00f8verst</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "3",
    "createdAt": "2019-09-09T12:50:17.055000+00:00"
  }, {
    "author": {
      "name": "Gunn Walmann",
      "email": "N/A"
    },
    "message": "<p>svar p\u00e5 svaret</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "4",
    "createdAt": "2019-09-09T12:50:36.171000+00:00"
  }, {
    "author": {
      "name": "\u00d8yvind Volden",
      "email": "N/A"
    },
    "message": "<aside class=\"quote no-group\" data-post=\"2\" data-topic=\"1525\">\n<div class=\"title\">\n<div class=\"quote-controls\"></div>\n<img alt=\"\" width=\"20\" height=\"20\" src=\"/user_avatar/discourse.dimu.org/gunn_walmann/40/6_2.png\" class=\"avatar\"> Gunn_Walmann:</div>\n<blockquote>\n<p>M\u00e5 v\u00e6re noe som fungerer her.</p>\n</blockquote>\n</aside>\n<p>Jeg tror rett og slett det som svares p\u00e5 i staben ikke regnes som svar jeg. Kanskje det er knyttet til at det er en privat del av forumet</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "5",
    "createdAt": "2019-09-09T12:53:36.799000+00:00"
  }, {
    "author": {
      "name": "Gunn Walmann",
      "email": "N/A"
    },
    "message": "<p>Det h\u00f8res lurt ut. Vi g\u00e5r for den, til den blir motbevist. <img src=\"https://discourse.dimu.org/images/emoji/google/slight_smile.png?v=9\" title=\":slight_smile:\" class=\"emoji\" alt=\":slight_smile:\"></p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "6",
    "createdAt": "2019-09-09T12:54:26.041000+00:00"
  }, {
    "author": {
      "name": "Gunn Walmann",
      "email": "N/A"
    },
    "message": "<ul>\n<li>Men kanskje ikke vi skal legge opp til s\u00e5 mye kommunikasjon her. Vi har jo Teams ogs\u00e5. <img src=\"https://discourse.dimu.org/images/emoji/google/slight_smile.png?v=9\" title=\":slight_smile:\" class=\"emoji\" alt=\":slight_smile:\">\n</li>\n</ul>",
    "subject": "",
    "status": "unread",
    "uniqueId": "7",
    "createdAt": "2019-09-09T12:54:55.426000+00:00"
  }, {
    "author": {
      "name": "\u00d8yvind Volden",
      "email": "N/A"
    },
    "message": "<p>Og der ble det motbevist. Fikk varsel om det ene innlegget ditt. Jeg la kommunikasjonen hit med vilje for \u00e5 f\u00e5 litt datagrunnlag for testing i forumet her:)</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "8",
    "createdAt": "2019-09-09T13:09:09.907000+00:00"
  }, {
    "author": {
      "name": "Gunn Walmann",
      "email": "N/A"
    },
    "message": "<p>Puh! Da er det vel p\u00e5 tide \u00e5 g\u00e5 hjem, og h\u00e5pe at det g\u00e5r over til i morgen.</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "9",
    "createdAt": "2019-09-09T13:26:58.781000+00:00"
  }, {
    "author": {
      "name": "Trond Ivar Hensgaard",
      "email": "N/A"
    },
    "message": "<p>Sikker p\u00e5 at du er motbevist?</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "10",
    "createdAt": "2019-09-16T13:21:44.130000+00:00"
  }, {
    "author": {
      "name": "\u00d8yvind Volden",
      "email": "N/A"
    },
    "message": "<p>Velkommen til forumet! Ble oppfordret av discourse \u00e5 \u00f8nske deg velkommen</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "11",
    "createdAt": "2019-09-16T13:24:02.062000+00:00"
  }, {
    "author": {
      "name": "\u00d8yvind Volden",
      "email": "N/A"
    },
    "message": "<p>Svarer direkte p\u00e5 posten denne gangen.</p>",
    "subject": "",
    "status": "unread",
    "uniqueId": "12",
    "createdAt": "2019-09-16T13:41:29.608000+00:00"
  }],
  "ownerName": null,
  "createdAt": "2019-09-09T11:06:45.472000+00:00"
};